import React, { useEffect } from 'react';
import useMediaQuery from 'hooks/useMediaQuery';
import { Breakpoints } from 'configs/breakpoints';
import Image from 'components/Image/Image';
import { useTheme } from 'contexts/ThemeContext';
import classnames from 'classnames';
import GoogleAnalytics from 'utils/googleAnalytics/googleAnalytics';
import { getContent } from './SuccessStory.content';
import tracking from './SuccessStory.tracking';
import style from './SuccessStory.module.scss';

const SuccessStory = () => {
    const isMobile = useMediaQuery(Breakpoints.VERY_SMALL);

    const handleDiscoverHowClick = () => {
        GoogleAnalytics.sendEvent(tracking.clickOnDiscoverHowButton);
    };

    const { theme } = useTheme();
    const { title, subtitle, button, bgMobile, bgDesktop, bgDesktopCompress, bgMobileCompress, note } = getContent();
    useEffect(smoothscrollAnchorPolyfillInit, []);
    return (
        <section className={classnames(style[theme], style.successStorySection)}>
            {isMobile ? (
                <Image unCompressed={bgMobile} webp={bgMobileCompress} lazy={false} alt="background image" />
            ) : (
                <Image unCompressed={bgDesktop} webp={bgDesktopCompress} lazy={false} alt="background image" />
            )}
            <div className={style.sectionContainer}>
                <div className={style.content}>
                    <h1>{title}</h1>
                    <h2>{subtitle}</h2>
                    <div onClick={handleDiscoverHowClick} className={style.buttonWrapper}>
                        {button}
                    </div>
                    <div className={style.note}>{note}</div>
                </div>
            </div>
        </section>
    );
};

export default SuccessStory;

const smoothscrollAnchorPolyfillInit = () => {
    if (!('scrollBehavior' in document.documentElement.style)) {
        Promise.all([import('smoothscroll-polyfill'), import('smoothscroll-anchor-polyfill')]).then(
            ([smoothscrollPolyfill]) => {
                smoothscrollPolyfill.polyfill();
            },
        );
    }
};
